import { refreshCurrentUser } from 'serviceWorker/services/permissions';
import { updatePersonalData, updateSuperadminLabel } from 'serviceWorker/services/currentUser/updateCurrentUser';
import { identifyCurrentUser } from 'serviceWorker/services/currentUser/identity';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { currentUserContract } from 'shared/domain/currentUser/currentUserContract';

/** Downloads the logged-in user and saves the user's own data. */
export function serveCurrentUserRequests(): ChannelUnsubscribe {
  return channelServer.handle(currentUserContract, {
    refresh: () => refreshCurrentUser(),
    updatePersonalData,
    updateSuperadminLabel,
    identify: identifyCurrentUser,
  });
}
